import * as ng from 'angular';
import {FatturaElettronicaPassivaService} from '../../../../../services/fattura-elettronica-passiva.service';
import {PreviewService} from '../../../../../services/preview.service';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {FileService} from '../../../../../services/file.service';
import {StoreService} from '../../../../../services/store.service';
import {TableHeaderItem} from '../../../../../commons/components/table-component/domain/table-header-item';
import {AlertService} from '../../../../../services/ui/alert.service';
import {IFatturaPassivaItem} from '../../../../../commons/interfaces/invoices/passive';
import {IResultResponse} from '../../../../../commons/interfaces/IResultResponse';

declare let packageType: any;

export interface IFilter {
  user: string;
  _id: string;
  status: string;
  invoice_number: string;
  annual_progressive: string;
  document_type: string;
  date_from: Date;
  date_to: Date;
  company_name: string;
  piva: string;
  fiscal_code: string;
  sdi_id: number;
  date_ricezione_from: Date;
  date_ricezione_to: Date;
  pageNumber: number;
  pageSize: number;
  protocol: {
    status: string;
    value: string;
  };
}

export interface ISettings {
  filter: IFilter;
  sortField: string;
  sortDirection: number;
  pageSizes: number[];
  itemsCount: number;
}

export const PRFatturaElettronicaPassivaComponent = {
  template: require('./pr-fattura-elettronica-passiva.html'),
  controller: class PRFatturaElettronicaPassivaComponent {

    static $inject: string[] = [
      '$scope',
      '$state',
      '$stateParams',
      '$sce',
      '$uibModal',
      'ArchiSmallServices',
      'FileService',
      'StoreService',
      'FatturaElettronicaPassivaService',
      'PreviewService',
      'AlertService'
    ];

    private headerColumns: Array<TableHeaderItem>;

    constructor(
      private $scope: {
        settings: ISettings
        items: IFatturaPassivaItem[]
        selectedFatture: IFatturaPassivaItem[]
        [key: string]: any
      },
      private $state: ng.ui.IStateService,
      private $stateParams: ng.ui.IStateParamsService,
      private $sce: ng.ISCEService,
      private $uibModal: ng.ui.bootstrap.IModalService,
      private ArchiSmallServices: ArchiSmallServices,
      private fileService: FileService,
      private storeService: StoreService,
      private fatturaElettronicaPassivaService: FatturaElettronicaPassivaService,
      private _previewService: PreviewService,
      private alertService: AlertService
    ) {
      /* tslint:disable:no-string-literal */
      $scope.pageHeader = 'Fatture Ricevute';
      $scope.selectedItems = [];
      $scope.selectedFatture = [];
      $scope.items = [];
      $scope.moreDataToLoad = true;
      let processingRequest = false;

      this.headerColumns = [
        {key: 'status', label: 'Stato', ratio: '6', isSortable: true},
        {key: 'invoice_number', label: 'N. fattura', ratio: '11', isSortable: true},
        {key: 'sdi_id', label: 'Id Sdi', ratio: '9', isSortable: true},
        {key: 'annual_progressive', label: 'Prog. Annuale', ratio: '10', isSortable: true},
        {key: 'document_type', label: 'Tipo Doc.', ratio: '8', isSortable: true},
        {key: 'date', label: 'Data', ratio: '7', isSortable: true},
        {key: 'date_ricezione', label: 'Data Ricezione', ratio: '8', isSortable: true},
        {key: 'company_name', label: 'Fornitore', ratio: '13', isSortable: true},
        {key: 'piva', label: 'P.Iva', ratio: '6', isSortable: true},
        {key: 'fiscal_code', label: 'Codice Fiscale', ratio: '6', isSortable: true},
        {key: 'protocol', label: 'Protocollo', ratio: '12', isSortable: false},
        {key: 'has_attachment', label: 'Allegati', ratio: '10', isSortable: true}
      ];

      let trusted = {};

      $scope.statoDescription = (status, number, details) => {
        switch (status) {
          // case 'Ricevuta':
          //     return trusted['ricevuta'] || (trusted['ricevuta'] = $sce.trustAsHtml('<span>Hai ricevuto una nuova fattura elettronica da un tuo fornitore. Selezionala e visualizza il pdf. Hai 15 giorni di tempo per decidere se accettare o rifiutare con i pulsanti qui a lato \'AccettaAccetta Fattura\' o \'Rifiuta Fattura\'.</span><br/>'));
          case 'Accettata':
            return trusted['accettata'] || (trusted['accettata'] = $sce.trustAsHtml('<span>Hai accettato la fattura. Significa che intendi saldare tale fattura entro i termini indicati nella stessa o stabiliti col fornitore.</span><br/>'));
          case 'Rifiutata':
            return trusted['rifiutata'] || (trusted['rifiutata'] = $sce.trustAsHtml('<span>Hai Rifiutato la fattura del tuo fornitore. Se non la hai già contabilizzata il fornitore te ne potrà mandare un \'altra corretta con stesso numero fattura e stessa data fattura.</span>'));
          case 'Scaduta':
            return trusted['scaduta'] || (trusted['scaduta'] = $sce.trustAsHtml('<span>Sono passati 15 giorni dalla ricezione della fattura e sono decorsi i termini per ogni altra comunicazione su questa fattura. Se non intendi saldare il tuo fornitore dovrà inviarti Nota di Credito e nuova fattura. Se la ritieni corretta comunica al fornitore che la salderai. Ti diamo la possibilità di ricordare la tua scelta su questa fattura cliccando su \'Accetta Fattura\' o \'Rifiuta Fattura\': queste azioni però non invieranno alcuna notifica al SdI o al fornitore, serviranno a tuo scopo personale per tenerti allineato sulla situazione delle tue Fatture Passive.</span><br/>'));
          case 'Accettata dopo Scadenza':
            return trusted['accettata-dopo-scadenza'] || (trusted['accettata-dopo-scadenza'] = $sce.trustAsHtml('<span>Questo stato non invia nessuna notifica al SdI, serve per ricordarti che salderai la fattura al fornitore anche se è scaduta.</span><br/>'));
          case 'Rifiutata dopo Scadenza':
            return trusted['rifiutata-dopo-scadenza'] || (trusted['rifiutata-dopo-scadenza'] = $sce.trustAsHtml('<span>Questo stato non invia nessuna notifica al SdI o al tuo fornitore, serve per ricordarti che non intendi saldare la fattura. Ti consigliamo di registrarla contabilmente poichè il fornitore dovrà spedirti Nota di Credito e nuova fattura, non potrà inviarti la stessa.</span><br/>'));
        }
      };

      $scope.documentStatuses = [
        {name: '', class: ''},
        {name: 'Importata', class: 'label-warning'},
        {name: 'Ricevuta', class: 'label-warning'},
        {name: 'Accettata', class: 'label-success'},
        {name: 'Rifiutata', class: 'label-danger'},
        {name: 'Scaduta', class: 'label-default'},
        {name: 'Accettata dopo Scadenza', class: 'label-success'},
        {name: 'Rifiutata dopo Scadenza', class: 'label-danger'}
      ];

      $scope.openVisualizzaFilterModal = (size) => {
        let modalInstance = $uibModal.open({
          animation: true,
          component: 'fatturaElettronicaPassivaFilterComponent',
          size: size,
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            filter: () => {
              return $scope.settings;
            }
          }
        });

        modalInstance.result.then((settings) => {
          if (settings !== undefined) {
            $scope.settings = settings;
            $scope.settings.filter.pageNumber = 1;
            $scope.getItems();
          }
        }, (error) => {
          // ?
        });
      };

      $scope.getItemById = (id) => {
        for (let item in $scope.items) {
          if ($scope.items[item]._id === id) {
            $scope.selectedItem = $scope.items[item];
          }
        }
      };

      let modifyItem = (it) => {
        for (let item in $scope.items) {
          if ($scope.items[item]._id === it._id) {
            $scope.items[item] = it;
          }
        }
      };

      $scope.clearSelection = () => {
        $scope.selectedItems = [];
        for (let i = 0; i < $scope.items.length; i++) {
          $scope.items[i].isSelected = false;
        }
        $scope.selectAllValue = false;
      };

      $scope.settings = {
        filter: {
          user: this.storeService.getCurrentUser().sub,
          _id: '',
          status: decodeURIComponent($stateParams.status),
          invoice_number: decodeURIComponent($stateParams.numeroFattura),
          annual_progressive: '',
          document_type: '',
          date_from: undefined,
          date_to: undefined,
          company_name: '',
          piva: '',
          fiscal_code: '',
          sdi_id: undefined,
          date_ricezione_from: undefined,
          date_ricezione_to: undefined,
          pageNumber: 1,
          pageSize: 100,
          protocol: {
            status: '',
            value: ''
          }
        },
        sortField: '_id',
        sortDirection: -1,
        pageSizes: [20, 50, 100],
        itemsCount: undefined
      };

      $scope.getItems = () => {
        if (processingRequest) {
          return;
        }

        processingRequest = true;
        fatturaElettronicaPassivaService.getDocuments($scope.settings.filter, $scope.settings.sortField, $scope.settings.sortDirection)
          .then((response) => {
            const res = JSON.parse(JSON.stringify(response)) as IResultResponse<IFatturaPassivaItem>;

            if (res.Result === 1) {
              $scope.settings.itemsCount = res.itemsCount;
              let items = res.resultList;

              $scope.items = items;
              $scope.moreDataToLoad = true;

              processingRequest = false;
              if ($scope.items.length >= $scope.settings.itemsCount) {
                $scope.moreDataToLoad = false;
                return;
              }
            }

            $scope.selectedFatture = [];
            processingRequest = false;
          }, (error) => {
            this.alertService.alert('error', error);
            processingRequest = false;
          });
      };

      $scope.getItems();

      $scope.clearFilter = () => {
        $scope.settings.filter = {
          ...$scope.settings.filter,
          ...{
            status: '',
            invoice_number: '',
            annual_progressive: '',
            document_type: '',
            date_from: undefined,
            date_to: undefined,
            company_name: '',
            piva: '',
            fiscal_code: '',
            sdi_id: undefined,
            date_ricezione_from: undefined,
            date_ricezione_to: undefined,
            pageNumber: 1,
            protocol: {
              status: '',
              value: ''
            }
          }
        };

        $scope.moreDataToLoad = true;
        $scope.getItems();
      };

      $scope.statusList = ['Importata', 'Ricevuta', 'Accettata', 'Rifiutata', 'Scaduta', 'Accettata dopo Scadenza', 'Rifiutata dopo Scadenza'];

      $scope.WorkerFatturazioneGeneratePackageModal = (PackageType, docId) => {
        if (docId !== undefined) {
          // one document
          // if is requested DIP download of ONLY ONE doc
          // we verify if the DIP is set
          // and we download it in case of true

          let indexes = $.map($scope.items, (obj, index) => {
            if (obj._id === docId) {
              return index;
            }
          });
          if (indexes.length !== 1) {
            return;
          }

          if ($scope.items[indexes[0]].DIP.Status === 2) {
            this.fileService.downloadFile($scope.items[indexes[0]].DIP.FilePath);
            return;
          } else {
            if ($scope.items[indexes[0]].DIP.Status === 1) {
              return;
            }
            $scope.items[indexes[0]].DIP.Status = 1;

            ArchiSmallServices.updateConservazioneDIPStatus($scope.items[indexes[0]])
              .then((response: any) => {
                // res = response;
                $scope.getItems();
                $uibModal.open({
                  animation: true,
                  component: 'workerFatturazioneGeneratePackagePRModalComponent',
                  windowClass: 'center-modal',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    settings: {
                      'PackageType': PackageType,
                      'DocumentIds': [docId],
                      'user': this.storeService.getCurrentUser().sub
                    }
                  }
                });
              }, (error) => {
                this.alertService.alert('error', error);
              });
          }
        } else {// multiple documents
          if ($scope.selectedItems.length === 0) {
            return;
          }
          switch (PackageType) {
            case 'FatturaPassiva-PDF':
              PackageType = 'PDF';
              break;
            case 'FatturaPassiva-XML':
              PackageType = 'XML';
              break;
          }

          let WorkerModal = $uibModal.open({
            animation: true,
            component: 'workerFatturazioneGeneratePackagePRModalComponent',
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              settings: {
                'PackageType': 'FatturaPR-' + PackageType,
                'DocumentIds': $scope.selectedItems,
                'user': this.storeService.getCurrentUser().sub
              }
            }
          });
        }
      };

      $scope.contextMenuItemTitle = '<span><strong class=\'centered\'>' + $scope.selectedItems.length + ' items selected</strong></span>';
      $scope.contextMenuOptions = (itemDocument) => {
        $scope.menuOptionsSingle[0][0] = '<span><strong>Fattura ' + itemDocument.invoice_number + '</strong></span>';
        if (itemDocument.hasAttachment === false) {
          $scope.menuOptionsSingle[8][0] = '<i class=\'icon-icon_file link-disabled\'></i> <span class="link-disabled">Scarica Allegato</span>';
        } else {
          $scope.menuOptionsSingle[8][0] = '<i class=\'icon-icon_file\'></i> <span class="">Scarica Allegato</span>';
        }
        return $scope.menuOptionsSingle;
      };

      $scope.contextMenuItemPDF = '<i class=\'icon-icon_file_pdf\'></i> <span>Scarica File PDF</span>';
      $scope.contextMenuItemXML = '<i class=\'icon-icon_file_xml\'></i> <span>Scarica File XML</span>';
      $scope.contextMenuItemPreview = '<i class=\'fa fa-eye\'></i> <span>Anteprima</span>';
      $scope.contextMenuItemAllegato = '<i class=\'icon-icon_file\'></i> <span class="">Scarica Allegato</span>';

      $scope.menuOptionsSingle = [
        [$scope.contextMenuItemTitle, ($itemScope) => {
          //
        }],
        null,
        [$scope.contextMenuItemPDF, ($itemScope) => {
          this.fileService.downloadFile($itemScope.item.file_path_pdf);
        }],
        null,
        [$scope.contextMenuItemXML, ($itemScope) => {
          this.fileService.downloadFile($itemScope.item.file_path_xml);
        }],
        null,
        [$scope.contextMenuItemPreview, ($itemScope) => {
          _previewService.showPreview($itemScope.item, this.previewModal);
        }],
        null,
        [$scope.contextMenuItemAllegato, ($itemScope) => {
          this.fileService.downloadAttachment($itemScope.item);
        }]
      ];

      $scope.addOrRemoveSelectedItem = (item) => {
        $scope.selectedFatture = $scope.selectedFatture.filter(item => item.isSelected);
        if (item.isSelected && !$scope.selectedFatture.includes(item)) {
          $scope.selectedFatture = $scope.selectedFatture.concat(item);
        }
      };

      $scope.importPassiva = (size) => {
        const importModal = $uibModal.open({
          animation: true,
          component: 'importFatturePassiveModalComponent',
          windowClass: 'center-modal',
          size: size,
          backdrop: 'static',
          keyboard: false,
        });
        importModal.result.finally(() => {
          $scope.getItems();
        });

      };

      $scope.downloadPackage = (xml: boolean) => {
        if ($scope.selectedFatture.length === 1) {
          this.fileService.downloadFile(xml ? $scope.selectedFatture[0].file_path_xml : $scope.selectedFatture[0].file_path_pdf);
        } else {
          if (xml) {
            // console.log('gestione xml');

            // gestisci download xml
            $uibModal.open({
              animation: true,
              component: 'workerFatturazioneDownloadFatturePRModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                settings: {
                  type: 'fp_xml',
                  fatture: $scope.selectedFatture,
                  user: this.storeService.getCurrentUser().sub
                }
              }
            });
          } else {
            // gestione pdf
            // console.log('download pdf');

            $uibModal.open({
              animation: true,
              component: 'workerFatturazioneDownloadFatturePRModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                settings: {
                  type: 'fp_pdf',
                  fatture: $scope.selectedFatture,
                  user: this.storeService.getCurrentUser().sub
                }
              }
            });
          }
        }
      };

      $scope.acceptInvoice = (item, accepted, status_details) => {
        let details = {
          'id': item._id,
          'accepted': accepted,
          'status_details': status_details
        };

        fatturaElettronicaPassivaService.acceptInvoice(details)
          .then((response) => {
            item = response;
            modifyItem(item);
            $scope.settings.filter.pageNumber = 1;
            $scope.getItems();
          }, (error) => {
            this.alertService.alert('error', error);
          });
      };

      $scope.openAcceptInvoiceModal = (item, accepted, status) => {
        let templateUrl = this.getAcceptInvoiceModalTemplate(accepted, status);

        let modalInstance = $uibModal.open({
          animation: $scope.animationsEnabled,
          templateUrl: templateUrl,
          controller: 'AcceptFatturaElettronicaPassivaModalController',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            config: () => {
              return {
                headerIcon: 'fa fa-exclamation-triangle',
                headerText: 'Attenzione',
                'accepted': accepted,
                buttons: [
                  {
                    'id': 1,
                    'icon': 'fa fa-ban',
                    'label': 'Annulla'
                  },
                  {
                    'id': 2,
                    'icon': 'fa fa-check-circle-o',
                    'label': 'Si'
                  }
                ]
              };
            },
            status: () => {
              return status === undefined ? '' : status;
            }
          }
        });
        modalInstance.result.then((details) => {
          let pressedButtonId = details.buttonId;

          if (pressedButtonId !== undefined) {
            if (pressedButtonId === 2) {
              $scope.acceptInvoice(item, accepted, details.descrizione);
            }
          }
        }, () => {
          // ??
        });
      };
      $scope.exportCsv = () => {
        fileService.downloadCsv(fatturaElettronicaPassivaService.getDocumentsCsv($scope.settings.filter, $scope.settings.sortField, $scope.settings.sortDirection));
      };
    }

    openExportModal(size: string) {
      this.$uibModal.open({
        animation: true,
        component: 'exportComponent',
        size: size,
        windowClass: 'center-modal',
        resolve: {
          packageTypePrefix: () => {
            return 'FatturaPassiva';
          },
          user: () => {
            return this.storeService.getCurrentUser().sub;
          }
        }
      });
    }

    previewModal = (item, type) => {
      this.$uibModal.open({
        animation: true,
        component: 'previewModalComponent',
        controllerAs: 'vm',
        size: 'preview',
        resolve: {
          path: () => {
            return item.file_path_pdf;
          },
          type: () => {
            return type;
          }
        }
      });
    }

    updateProtocol(item: any) {
      this.fatturaElettronicaPassivaService.updateProtocol(item);
    }

    private getAcceptInvoiceModalTemplate(accepted: boolean, status: string) {
      let templateUrl = '';

      if (status !== undefined && status === 'scaduta') {
        templateUrl = '../accept-fattura-elettronica-passiva-modal/accept-expired-invoice-modal.html';

        if (!accepted) {
          templateUrl = '../accept-fattura-elettronica-passiva-modal/deny-expired-invoice-modal.html';
        }
      } else {
        templateUrl = '../accept-fattura-elettronica-passiva-modal/accept-invoice-modal.html';

        if (!accepted) {
          templateUrl = '../accept-fattura-elettronica-passiva-modal/deny-invoice-modal.html';
        }
      }

      return templateUrl;
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/pr-fattura-elettronica-passiva/pr-fattura-elettronica-passiva.ts